module.exports = __webpack_public_path__ + "static/media/COS_FOOTER_LOGO.43fc705d.jpg";